import React, { useEffect, useState } from 'react';
import Table from '../../../../components/Table/RsponsiveTable';
import BankSlabColumnData from './BankSlabColumnData';

const BankSlabTable = ({
  tableData,
  tableInfo,
  tableLoading,
  setPageSize,
  setPage,
  changeMonth
}) => {
  const [doRender, setRender] = useState(false);
  const customHandlePageChange = page => {
    setPage(page);
  };

  const customHandlePerRowsChange = (perPage, page) => {
    setPageSize(perPage);
    setPage(0);
  };

  return (
    <div className="w-full ">
      <Table
        dontShowAutoFilter={false}
        data={tableData}
        columns={BankSlabColumnData(changeMonth)}
        serverPagination={true}
        CustomhandlePerRowsChange={customHandlePerRowsChange}
        CustomhandlePageChange={customHandlePageChange}
        serverSort={false}
        TableInfo={tableInfo}
        tableLoading={tableLoading}
        filterComponent={false}
        rows="50"
        tableListbelongs="Leads"
        page={tableInfo?.number?.toString() || 0}
        showNumberOfListStyle={{ display: 'none' }}
        searchStyle={{ display: 'none' }}
        noPagination={true}
        render={doRender}
      />
    </div>
  );
};

export default BankSlabTable;
